export default {
  dbu_quarter_report_title: '季报',
  dbu_quarter_report_text1: '您的游戏数据MBTI是：',
  dbu_quarter_report_text11: '数据探索之旅',
  dbu_quarter_report_text2: '占比<span class="--percent">{number}%</span>的数据人格',
  dbu_quarter_report_text3: '快来看看你<br />的特殊身份!',
  dbu_quarter_report_activity_trend: `季度活跃趋势`,
  dbu_quarter_report_used_days: '本季度累计使用天数',
  dbu_quarter_report_total_activity: '本季度累计活跃度',
  dbu_quarter_report_favourite_game: '最爱游戏',
  dbu_quarter_report_favourite_genre: '最爱品类',
  dbu_quarter_report_context_menu_tips: '右键保存完整图片',

  // 高光时刻相关
  dbu_quarter_report_highlight_moment: '季度高光时刻',
  dbu_quarter_report_most_visited_page: '你本季度访问最多的页面',
  dbu_quarter_report_visited_game_on_date: '这天，\n你查看了《{gameName}》',
  dbu_quarter_report_visited_databrain_on_date: '这天，\n你访问DataBrain超过',
  dbu_quarter_report_times_unit: '次',

  // 用户偏好相关
  dbu_quarter_report_game_preference_profile: '游戏偏好档案',
  dbu_quarter_report_favourite_game_top3: '最爱游戏',
  dbu_quarter_report_top3_label: 'TOP3',
  dbu_quarter_report_favourite_entity_type: '最常访问类型',

  // 扫码相关
  dbu_quarter_report_scan_to_miniprogram: '扫码前往DataBrain小程序',
  dbu_quarter_report_scan_instruction_1: '右上角',
  dbu_quarter_report_scan_user_center: '用户中心',
  dbu_quarter_report_scan_quarterly_mbti: 'Quarterly MBTI',
  dbu_quarter_report_scan_instruction_3: '领取专属数据基因卡片，分享你的游戏数据MBTI!',

  dbu_quarter_report_game_data_gene_name_e: '无界漫游',
  dbu_quarter_report_game_data_gene_name_i: '定点爆破',
  dbu_quarter_report_game_data_gene_name_s: '游戏专精',
  dbu_quarter_report_game_data_gene_name_n: '行业猎手',
  dbu_quarter_report_game_data_gene_name_t: '数据极客',
  dbu_quarter_report_game_data_gene_name_f: '内容解析',
  dbu_quarter_report_game_data_gene_name_j: '金牌主理',
  dbu_quarter_report_game_data_gene_name_p: '业界军师',
  dbu_quarter_report_game_data_gene_description_e: '漫游多种页面',
  dbu_quarter_report_game_data_gene_description_i: '细品页面',
  dbu_quarter_report_game_data_gene_description_s: '在茫茫游戏中有所偏爱',
  dbu_quarter_report_game_data_gene_description_n: '扫描行业图谱',
  dbu_quarter_report_game_data_gene_description_t: '专注游戏客观表现',
  dbu_quarter_report_game_data_gene_description_f: '把握玩家舆论动向',
  dbu_quarter_report_game_data_gene_description_j: '精研内部生态',
  dbu_quarter_report_game_data_gene_description_p: '探索行业基准',

  // Quarter selector
  dbu_quarter_report_unavailable: '暂无数据',
  dbu_quarter_report_select_quarter: '选择季度',


  // 2025 Game Names
  dbu_quarter_report_2025_game_name_1: '命运守护夜Fate',
  dbu_quarter_report_2025_game_name_2: '最终幻想VII',
  dbu_quarter_report_2025_game_name_3: 'Fate/Zero',
  dbu_quarter_report_2025_game_name_4: '哈利波特',
  dbu_quarter_report_2025_game_name_5: '绝代双骄',
  dbu_quarter_report_2025_game_name_6: '三丽鸥',
  dbu_quarter_report_2025_game_name_7: '崩坏：星轨',
  dbu_quarter_report_2025_game_name_8: '王者荣耀',
  dbu_quarter_report_2025_game_name_9: '无敌破坏王',
  dbu_quarter_report_2025_game_name_10: '海贼王',
  dbu_quarter_report_2025_game_name_11: '英雄联盟',
  dbu_quarter_report_2025_game_name_12: 'Durarara!!',
  dbu_quarter_report_2025_game_name_13: '妖精的尾巴',
  dbu_quarter_report_2025_game_name_14: '鬼灭之刃',
  dbu_quarter_report_2025_game_name_15: '漫威系列游戏',

  // 2025 Role Names
  dbu_quarter_report_2025_role_name_istj: '阿尔托莉雅',
  dbu_quarter_report_2025_role_name_isfj: '蒂法',
  dbu_quarter_report_2025_role_name_infj: '卫宫切嗣',
  dbu_quarter_report_2025_role_name_intj: '斯内普',
  dbu_quarter_report_2025_role_name_istp: '花无缺',
  dbu_quarter_report_2025_role_name_isfp: '库洛米',
  dbu_quarter_report_2025_role_name_infp: '流萤',
  dbu_quarter_report_2025_role_name_intp: '露娜',
  dbu_quarter_report_2025_role_name_estp: '云妮洛普',
  dbu_quarter_report_2025_role_name_esfp: '波雅·汉库克',
  dbu_quarter_report_2025_role_name_enfp: '金克丝',
  dbu_quarter_report_2025_role_name_entp: '折原临也',
  dbu_quarter_report_2025_role_name_estj: '艾露莎',
  dbu_quarter_report_2025_role_name_esfj: '妲己',
  dbu_quarter_report_2025_role_name_enfj: '炭治郎',
  dbu_quarter_report_2025_role_name_entj: '钢铁侠',

  // 2025 Role Exclusive Copy
  dbu_quarter_report_2025_role_exclusive_copy_istj:
    '"Excalibur！" 在DataBrain，你用无可辩驳的数据守护历经市场考验的永恒经典，是最值得信赖的骑士王。',
  dbu_quarter_report_2025_role_exclusive_copy_isfj:
    '你以守护者的敏锐与耐心解读玩家心声，守护着能让玩家安心停靠、值得信赖的"第七天堂"。',
  dbu_quarter_report_2025_role_exclusive_copy_infj:
    '你是DataBrain世界中具有前瞻性的战略家，善于从数据中洞察游戏世界的本质，为更长远的目标制定策略。',
  dbu_quarter_report_2025_role_exclusive_copy_intj:
    '市场如同一锅复杂的魔药，而DataBrain平台就是你的实验室，你只信奉精准的配方，炼制出游戏世界的永恒经典。',
  dbu_quarter_report_2025_role_exclusive_copy_istp:
    '在DataBrain，你剔除所有冗余的情绪和噪音，只留下最核心的数据与逻辑，往往悄无声息地完成一套完美连招。',
  dbu_quarter_report_2025_role_exclusive_copy_isfp:
    '你从不追随大众雷达，凭着野生的直觉绕开流行榜单，精准锁定格调独特、即将引爆的宝藏游戏，只负责创造让世界尖叫的惊喜。',
  dbu_quarter_report_2025_role_exclusive_copy_infp:
    '你是在数据梦境中寻找秘密的流浪者，总能绕开那些浮华的表象，找到隐藏在数据深处、真正触动人心的情感共鸣。',
  dbu_quarter_report_2025_role_exclusive_copy_intp:
    '在DataBrain的世界里，你于静默中寻找标记间的连结点，规划好最优路径，用一套行云流水的"月下无限连"，精准刺穿表象，直达问题的核心。',
  dbu_quarter_report_2025_role_exclusive_copy_estp:
    '在DataBrain，你就是那个能发现"系统漏洞"的鬼马玩家，享受着在海量数据中极速漂移的快感，抢先一步抵达未被发现的蓝海。',
  dbu_quarter_report_2025_role_exclusive_copy_esfp:
    '在DataBrain，你以自己的"兴致"与"美感"为航向，漫步于这片数据之海，只有那些足够耀眼、能取悦你的游戏，才有资格进入你的视野。',
  dbu_quarter_report_2025_role_exclusive_copy_enfp:
    '砰砰砰！用爆裂的好奇心轰炸 DataBrain，你是穿梭在数据峡谷中的暴走萝莉，用直觉和热情引爆下一个流行趋势，总能让所有人眼前一亮！',
  dbu_quarter_report_2025_role_exclusive_copy_entp:
    '"人类LOVE！" 在DataBrain，你总能轻松玩转海量数据，挖掘出其中千丝万缕的联系，并精准预测下一次潮流，整个数据平台就是你最爱的人类池袋。',
  dbu_quarter_report_2025_role_exclusive_copy_estj:
    '作为DataBrain世界的"妖精女王"，你总能像"换装魔法"一样，为不同挑战配备最精准的数据策略，坚信清晰的目标和可靠的执行力是通往胜利的唯一道路。',
  dbu_quarter_report_2025_role_exclusive_copy_esfj:
    '"让妲己看看你的心～" 你是DataBrain平台最懂玩家情绪的小狐仙，凭借对大众喜好与潮流的敏锐直觉，轻松定义风潮。',
  dbu_quarter_report_2025_role_exclusive_copy_enfj:
    '"心を燃やせ！"(燃烧心灵！) 你的善良与同理心，就是最强大的力量，从客观精确的数据中，感受到用户最真实的情感与渴望，是DataBrain不倦的先行者。',
  dbu_quarter_report_2025_role_exclusive_copy_entj:
    '"Jarvis, run the numbers." 你是DataBrain平台极具前瞻性的战略家,一声令下,整个游戏市场的蓝图便在数据中展开,你的每一次出手,都在定义下一个爆款的公式。',


  // 2026 Game Names
  dbu_quarter_report_2026_game_name_1: '恋与深空',     
  dbu_quarter_report_2026_game_name_2: '间谍过家家',
  dbu_quarter_report_2026_game_name_3: '辉夜大小姐想让我告白',
  dbu_quarter_report_2026_game_name_4: '咒术回战',
  dbu_quarter_report_2026_game_name_5: '进击的巨人',
  dbu_quarter_report_2026_game_name_6: '鬼灭之刃',
  dbu_quarter_report_2026_game_name_7: 'NIKKE',
  dbu_quarter_report_2026_game_name_8: 'BanG Dream!',
  dbu_quarter_report_2026_game_name_9: '恋与制作人',
  dbu_quarter_report_2026_game_name_10: '五等分的新娘',
  dbu_quarter_report_2026_game_name_11: '元气少女缘结神',
  dbu_quarter_report_2026_game_name_12: '电锯人',

  // 2026 Role Names
  dbu_quarter_report_2026_role_name_istj: '黎深',
  dbu_quarter_report_2026_role_name_isfj: '约尔·福杰',
  dbu_quarter_report_2026_role_name_infj: '早坂爱',
  dbu_quarter_report_2026_role_name_intj: '夏油杰',
  dbu_quarter_report_2026_role_name_istp: '利威尔',
  dbu_quarter_report_2026_role_name_isfp: '艾伦·耶格尔',
  dbu_quarter_report_2026_role_name_infp: '时透无一郎',
  dbu_quarter_report_2026_role_name_intp: '沈星回',
  dbu_quarter_report_2026_role_name_estp: 'Red Hood',
  dbu_quarter_report_2026_role_name_esfp: '千早爱音',
  dbu_quarter_report_2026_role_name_enfp: '周棋洛',
  dbu_quarter_report_2026_role_name_entp: '五条悟',
  dbu_quarter_report_2026_role_name_estj: '中野二乃',
  dbu_quarter_report_2026_role_name_esfj: '桃园奈奈生',
  dbu_quarter_report_2026_role_name_enfj: '玛奇玛',
  dbu_quarter_report_2026_role_name_entj: 'Dorothy',

  // 2026 Role Exclusive Copy
  dbu_quarter_report_2026_role_exclusive_copy_istj:
    '你将每一份数据都视作一封等待解读的信件，以心外科手术般的严谨，从字里行间探寻用户最真实的渴望与需求。',
  dbu_quarter_report_2026_role_exclusive_copy_isfj:
    '你无需多言，只是默默守护着最重要的那一箱数据，以超越言语的温柔与坚韧，感知用户心底最真实的渴望。',
  dbu_quarter_report_2026_role_exclusive_copy_infj:
    '「这也是工作的一部分。」在 DataBrain，你游刃有余地切换不同"身份"的分析视角，以近侍般的冷静和洞察，为迷失的趋势悄然指路。',
  dbu_quarter_report_2026_role_exclusive_copy_intj:
    '你认为真理只属于少数精英，以缜密的数据计算推演通往目标的每一步，构建一个只为"咒术师"敞开的清晰世界。',
  dbu_quarter_report_2026_role_exclusive_copy_istp:
    '你挥舞着立体机动装置般的分析利刃，在海量数据中精准穿行，用最快的速度，直击问题核心的"后颈"。',
  dbu_quarter_report_2026_role_exclusive_copy_isfp:
    '为了去看墙外的风景，你用不屈的意志驱使数据，向着你所坚信的自由，发起一次又一次地鸣般的进击。',
  dbu_quarter_report_2026_role_exclusive_copy_infp:
    '你如飘渺的霞之呼吸，在数据的迷雾中凭空灵的直觉挥刀，于静默的沉思里捕捉到勘破本质的那一线微光。',
  dbu_quarter_report_2026_role_exclusive_copy_intp:
    '「我的光，会找到答案。」你看似慵懒随性，却拥有猎人般的直觉，总能在纷繁的数据里，光速捕获那个最关键的变数。',
  dbu_quarter_report_2026_role_exclusive_copy_estp:
    '你是方舟外失控的"红色野兽"，凭本能与火力在数据荒野中疾驰，用干脆利落的一击，拿下每一个转瞬即逝的机会。',
  dbu_quarter_report_2026_role_exclusive_copy_esfp:
    '你是点燃逆境的终焉之火，用天真烂漫的热情，将每一次临界的走势，都化为守护希望的闪耀乐章。',
  dbu_quarter_report_2026_role_exclusive_copy_enfp:
    '你用偶像般的感染力，将零散的市场传闻与玩家故事编织成一首首轻盈的诗，奏响数据创新的浪漫乐章。',
  dbu_quarter_report_2026_role_exclusive_copy_entp:
    '「大丈夫。僕最強だから。」在 DataBrain，你展开无量空処般的领域，让所有复杂的数据信息，都在你无下限的洞察力前显露无遗。',
  dbu_quarter_report_2026_role_exclusive_copy_estj:
    '如同守护姐妹的羁绊，你以不容置疑的强势主导着数据的秩序，用直接而高效的方式，确保没有一个目标脱离计划。',
  dbu_quarter_report_2026_role_exclusive_copy_esfj:
    '你用温暖的共情力将零散的数据连接成一个社群，让每一位玩家都在 DataBrain 收获如神社般的归属感。',
  dbu_quarter_report_2026_role_exclusive_copy_enfj:
    '「这是命令。」在 DataBrain，你以温柔而绝对的掌控力，调度庞杂的市场数据，让它们成为为你服务的"眼睛"和情报网。',
  dbu_quarter_report_2026_role_exclusive_copy_entj:
    '「乐园就该有乐园的样子。」你以女王的远见与严谨的标准，指挥数据搭建通往完美胜利的理想乐园。',
};
